export default __webpack_public_path__ + "static/media/create_token_button.50f9347b.png";